import Vue from 'vue';
import store from '../../store';
import Modal from './PhoneModal';

let instance;

function isInDocument(element) {
  return document.body.contains(element);
}

function initInstance() {
  if (instance) {
    instance.$destroy();
  }

  instance = new (Vue.extend({
    ...Modal,
    store
  }))({
    el: document.createElement('div'),
    // avoid missing animation when first rendered
    propsData: {
      lazyRender: false,
    },
  });
  document.body.appendChild(instance.$el);

  instance.$on('input', (value) => {
    instance.value = value;
  });
}


function PhoneModal(options) {
  return new Promise((resolve, reject) => {
    if (!instance || !isInDocument(instance.$el)) {
      initInstance();
    }

    Object.assign(instance, PhoneModal.currentOptions, options, {
      resolve,
      reject,
    });
  });
}

PhoneModal.show = (options) =>
  PhoneModal({
    value: true,
    ...options,
  });

PhoneModal.close = () => {
  if (instance) {
    instance.value = false;
  }
};

PhoneModal.currentOptions = {
  value: false,
  onComplete: ()=>{},
  close: () => {
    if (instance) {
      instance.value = false;
    }
  }
}

export default PhoneModal;